import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=5d9c4bec&"
import script from "./PostAdd.vue?vue&type=script&lang=js&"
export * from "./PostAdd.vue?vue&type=script&lang=js&"
import style0 from "./PostAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports